import { useTranslation } from 'react-i18next';
import React, { Fragment, useEffect, useState } from 'react'
import Layout from '../shared/components/LayoutComponent'
import Page from '../shared/components/PageComponent'
import { Button, Grid, Box, FormControl, InputLabel, Select, OutlinedInput, MenuItem, useTheme, Input, Typography, Avatar, CircularProgress } from "@mui/material";
import DynamicTable from "../shared/components/DynamicTableComponent";
import { FileUploadComponent } from '../lib';
import apiRequest from '../../functions/api';
import { useMessage } from '../../context/message-context';
import openFile from '../shared/functions/download';
import axios from 'axios';
import { API_BASE_URL } from '../../constants/apiConstants';
import InputBox from '../shared/components/InputBox';
import { element } from 'prop-types';

const SerienBrief = ({ client, accessToken }) => {
  const [selectedSeite, setSelectedSeite] = useState({})
  const [options, setOptions] = useState([]);
  const [data, setData] = useState();
  const [dataZuord, setDataZuord] = useState(false);
  const [zeilen, setZeilen] = useState([]);
  const [spalten, setSpalten] = useState([]);
  const [suchbegriff, setSuchbegriff] = useState(["Personalnummer (Zahl)", "Name", "Vorname"]);
  const [selectedFile, setSelectedFile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [openibox,setOpenIBox] = useState(false);
  const [fragen,setFragen] = useState([]);
  const [iboxtitle,setIBoxTitle]=useState("");
  const { hideMessage, showErrorMessage, showSuccessMessage } = useMessage();
  const [isSending, setIsSending] = useState(false);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const onClickHandler = () => {
    setIsSending(true);
    if (!selectedFile) {
      showErrorMessage(t("Keine Datei ausgewählt"));
      return
    }
    const data = new FormData();
    hideMessage()
    setIsSending(true);
    data.append('file', selectedFile);
    const headers = {
      "Authorization": "Bearer " + accessToken,
      "Mandant": client, // this.props.client,
      "FileName": selectedFile.name,
      "program": "WEBPST",
      "statement": "PDF_AUFTEILEN",
    }
    apiRequest('POST', 'upload', data, headers, dataCb);
  }
  const dataCb = (response) => {
    if (response.status === 200) {
      if (response.data) {
        setIsSending(false);
        setData(response.data.table)
        setZeilen(response.data.table.zeilen)
        setSpalten(response.data.table.spalten)
      }
      if (response.data.message === 'ok') {
        showSuccessMessage(t("Upload erfolgreich."));
      }
    } else {
      setIsSending(false);
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Es ist etwas schief gelaufen. Bitte versuchen Sie es später erneut."));
      }
    }
  }
  const handleChange = (event) => { 
    setSuchbegriff(event.target.value);
  };
 
  const Auswaehle = ["Personalnummer (Zahl)", "Name", "Vorname", "Personalnummer (7-stellig)", "Personalnummer extern (Zahl)", "Personalnummer extern (8-stellig)", "Erster Buchstabe Vorname zzgl Punkt <M.>"];
  function onItemClick(spalteKey, zeileKey) {
    const tempzeile = zeilen.find((element => element.key === zeileKey))
     // setSelectedSeite({ "key": tempzeile.key, "pfad": tempzeile.PFAD })
    const payload = {
      "mandant": client,
      "program": "WEBPST",
      "statement": "PDF_HOLEN",
      "name": tempzeile.SEITE,
      "pfad":tempzeile.PFAD,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    axios.post(API_BASE_URL + 'daten', payload, { headers: headers, responseType: 'blob' })
      .then((response) => {
        var fileName =tempzeile.SEITE+".pdf" ;
        var contentFile = response.data;
        openFile(fileName, contentFile);
      })
      .catch(function (error) {
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      })
  }
  const onZuordnungClick = ()=>{
    setIsLoading(true);
    const headers={
      "Authorization": "Bearer "+accessToken,
  }
  const payload = {
      "mandant": client,
      "program": "WEBPST",
      "statement": "PDF_PNR_ZUORDNEN",
      "suchbegriff": suchbegriff,
      "table":data,
      
  }
  apiRequest('POST', 'daten', payload, headers, zuordnungCb);
  } 
  const zuordnungCb= (response)=>{
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.message === 'ok') {
        showSuccessMessage(t("Upload erfolgreich."));
        setData(response.data.table);
        setZeilen(response.data.table.zeilen);
        setSpalten(response.data.table.spalten);
        setDataZuord(true);
      }
    } else {
      
      if (response) {
        showErrorMessage(response.data.message);
        setData(response.data.table)
        setZeilen(response.data.table.zeilen)
        setSpalten(response.data.table.spalten)
      } else {
        showErrorMessage(t("Es ist etwas schief gelaufen. Bitte versuchen Sie es später erneut."));
      }
    }
  }
  
  const goPfldoksZuordnung = ()=>{
    setIsLoading(true);
    const headers={
      "Authorization": "Bearer "+accessToken,
  }
  const payload = {
      "mandant": client,
      "program": "WEBPST",
      "statement": "PDF_PFLDOKS_PNR_ZUORDNEN_1",
  }
  apiRequest('POST', 'daten', payload, headers, zuordnungPflDok);
  } 
  const inputBoxResult = (results) => {
    setIsLoading(true);
    const payload={
      "mandant": client,
      "program": "WEBPST",
      "statement": "PDF_PFLDOKS_PNR_ZUORDNEN_2",
      "table":data,
      "antworten": results,
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, zuordnungPflDok2);
  }
  
  const zuordnungPflDok= (response)=>{
    setIsLoading(false);
    if (response.data.fragen) {
      setFragen(response.data.fragen);
      setOpenIBox(true)
      if (response.data.titel) {
        setIBoxTitle(response.data.titel);
      }
    }
  }
  const zuordnungPflDok2= (response)=>{
    setIsLoading(false);
    if (response.status === 200) {
      setOpenIBox(false);
      setDataZuord(false);
      setData(false);
  
      if (response.data) {
        setData(response.data.table)
        setZeilen(response.data.table.zeilen)
        setSpalten(response.data.table.spalten)
      }
      if (response.data.message === 'ok') {
        showSuccessMessage(t("Upload erfolgreich."));
      }
    } else {
        showErrorMessage(t("Es ist etwas schief gelaufen. Bitte versuchen Sie es später erneut."));
      }
  }
  return (
    <Page>
      <Layout>
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12} sm={6}>
                <Box p={2}>
                  <FileUploadComponent variant="contained" children="PDF Dokumente importieren" color="primary" id="file-input" onChange={setSelectedFile} />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box p={2}>
                  {selectedFile && <Button
                    endIcon={isSending ? <CircularProgress /> : null}
                    variant="contained"
                    color="primary"
                    onClick={onClickHandler}
                    fullWidth>
                    Hochladen</Button>}
                  {selectedFile ? <span ><Typography >{selectedFile.name}</Typography></span> : <Typography color="textSecondary" >{"Keine Datei ausgewählt"}</Typography>}
                </Box>
              </Grid>
              {data &&
                <Grid item xs={12} sm={6}>
                  <Box p={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={onZuordnungClick}
                      >
                      {t("Pnr Zuordnung starten")}
                      </Button>
                  </Box>
                </Grid>
              }
            </Grid>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="center">
              <Grid item sm={6}>
                <Box p={2}>
                  <FormControl fullWidth >
                    <InputLabel >{t("Auswahl Suchbegriff")}</InputLabel>
                    <Select
                      multiple
                      value={suchbegriff}
                      onChange={handleChange}
                      input={<Input />}
                      MenuProps={MenuProps}>
                      {Auswaehle.map((Auswahl) => (
                        <MenuItem
                          key={Auswahl}
                          value={Auswahl}
                        >
                          {Auswahl}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
              {dataZuord &&
                <Box p={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={goPfldoksZuordnung}>
                    {t("Mitarbeiterzuordnung")}
                    </Button>
                </Box>
              }
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <DynamicTable zeilen={zeilen} spalten={spalten}  buttonCb={(spalteKey, zeileKey) => onItemClick(spalteKey, zeileKey)} leertext={"keine Datai gefunden"} hoehe={700} minbreite={500} options={options} size={"small"} />
      </Layout>
      {/* {(showModal )&& <FullPageSpinner/>} */}
      <Fragment>
      <InputBox
        open={openibox}
        handleResponse={inputBoxResult}
        fragen={fragen}
        title={iboxtitle}
        onClose={() => setOpenIBox(false)}
      />
    </Fragment>
    </Page >
    
  )
}
export default SerienBrief
